export default {"src":"/_next/static/media/cross.7fb8b7ae.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};